// Form
import { Controller, useFormContext } from "react-hook-form"
import { IoSendSharp } from "react-icons/io5"


export function TradingTerm(params: { name: string }) {
  // Form
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={params.name}
      render={({ field }) => (
        <div className="normal-case flex justify-evenly items-center pt-10">
          <div className="flex flex-col gap-2">
            <span>TRADING TERM </span>
            <span>PRICE LEVEL</span>
          </div>

          <div className="px-2 flex flex-col gap-2">
            <IoSendSharp />
            <IoSendSharp />
          </div>

          <div className="flex flex-col gap-2">
              <span>Net {field.value} Days after OEM </span>
              <span>-</span>
          </div>
        </div>
      )}
    />
  )
}